module.exports = __webpack_public_path__ + "img/icon_clock_with_background.81136b0c.svg";